import {
  ChangeCurrentCartTypeSucceededAction,
  changeCurrentCartSelectedStoreRequested
} from '../../carts/cartsSlice';
import { put, select } from 'typed-redux-saga';
import { CustomOrderType } from '../../carts/CustomOrderType';
import generateActionId from '../../../generateActionId';
import selectOptionalSessionContent from '../../session/selectors/selectOptionalSessionContent';

function* syncFavoriteStoreOnCartTypeSwitchSaga({
  payload: { cart, targetCustomOrderType }
}: ChangeCurrentCartTypeSucceededAction): Generator {
  if (targetCustomOrderType !== CustomOrderType.COLLECT_AT_STORE) {
    return;
  }
  const session = yield* select(selectOptionalSessionContent);
  const favoriteStoreId: string | null = session?.favoriteStoreId ?? null;
  if (favoriteStoreId === null) {
    return;
  }
  const cartStoreCode: string | null = cart.deliveryAddress?.storeCode ?? null;
  if (cartStoreCode === favoriteStoreId) {
    return;
  }
  yield* put(
    changeCurrentCartSelectedStoreRequested({
      actionId: generateActionId(),
      storeCode: favoriteStoreId
    })
  );
}

export default syncFavoriteStoreOnCartTypeSwitchSaga;
